/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cost_Per_PortionInputs */

const en_cost_per_portion = /** @type {(inputs: Cost_Per_PortionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost per portion`)
};

const de_cost_per_portion = /** @type {(inputs: Cost_Per_PortionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosten pro Portion`)
};

/**
* | output |
* | --- |
* | "Cost per portion" |
*
* @param {Cost_Per_PortionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_per_portion = /** @type {((inputs?: Cost_Per_PortionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Per_PortionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cost_per_portion(inputs)
	return en_cost_per_portion(inputs)
});